import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query/src/types';
import { useSelector } from 'react-redux';

import { ETripEvent } from 'detailsv2/structure';
import { accountIdSelector } from 'store/user/selectors';
import axiosApi from 'utils/axios';

import * as types from './types';

export const useTripEventDefaultValuesQuery = (
  attachedPage?: types.AttachedPage,
  eventType?: ETripEvent,
  options?: UseQueryOptions<types.TripEvemtDefaultValuesQueryRes>,
) => {
  const accountId = useSelector(accountIdSelector);

  const pageId = attachedPage?.id;
  const pageName = attachedPage?.name;

  return useQuery<types.TripEvemtDefaultValuesQueryRes>(
    ['defaultTripEventValues', pageId, pageName],
    () =>
      axiosApi
        .get(`/acc/${accountId}/trip_event_default_values`, {
          params: { event_type: eventType, page_id: pageId, page_name: pageName },
        })
        .then(({ data }) => data),
    {
      ...options,
      enabled: !!pageId || !!pageName,
    },
  );
};
